package ui.campaign.detailv2.widgets

import api.ResourceType
import common.frontend.api.Io
import org.ssoft.common.type.ScreenRatio
import playlist.ImplPlaylist
import kotlin.time.Duration

object ImplCampaignInfoCard {

    class VisualDynamic(
        var conditions: ImplPlaylist.Conditions,
        val weatherPictogramVariants: List<Io.Campaign.WeatherPictograms>,
        val visuals: List<Visual>,
    )

    class Visual(
        val id: Long,
        val width: Int,
        val height: Int,
        val duration: Duration,
        val type: ResourceType,
        val ratio: ScreenRatio,
        val onClick: ((id: Long) -> Unit)? = null
    )


    class Location(
        val id: Long,
        val name: String,
        val devices: List<Device>,
        val onClick: ((id: Long) -> Unit)? = null
    )

    class Device(
        val id: Long,
        val name: String,
        val countUsableDays: Int,
        val impressionSum: Long,
        val onClick: ((id: Long) -> Unit)? = null
    )
}